import * as React from 'react';
import {
  ContinuumProvider as BaseProvider,
  buildStyledContinuumTestingProvider,
} from '@pagerduty/continuum.theme';
import { THEMES as AvatarThemes } from '@pagerduty/continuum.avatar';
import { THEMES as BadgeThemes } from '@pagerduty/continuum.badge';
import { THEMES as ButtonThemes } from '@pagerduty/continuum.button';
import { THEMES as ContentThemes } from '@pagerduty/continuum.content';
import { THEMES as ErrorPageThemes } from '@pagerduty/continuum.errorpages';
import { THEMES as HeadingThemes } from '@pagerduty/continuum.heading';
import { THEMES as IconThemes } from '@pagerduty/continuum.icons';
import { THEMES as InputsThemes } from '@pagerduty/continuum.inputs';
import { THEMES as LayoutThemes } from '@pagerduty/continuum.layout';
import { THEMES as LinkThemes } from '@pagerduty/continuum.link';
import { THEMES as NavigationThemes } from '@pagerduty/continuum.navigation';
import { THEMES as OverlaysThemes } from '@pagerduty/continuum.overlays';
import { THEMES as SpinnerThemes } from '@pagerduty/continuum.spinner';
import { THEMES as TextThemes } from '@pagerduty/continuum.text';

const EXTRA_COMPONENTS = [
  ...AvatarThemes,
  ...BadgeThemes,
  ...ButtonThemes,
  ...ContentThemes,
  ...ErrorPageThemes,
  ...HeadingThemes,
  ...IconThemes,
  ...InputsThemes,
  ...LayoutThemes,
  ...LinkThemes,
  ...NavigationThemes,
  ...OverlaysThemes,
  ...SpinnerThemes,
  ...TextThemes,
];

interface ContinuumProviderProps {
  children: React.ReactNode;
  id?: string;
}

export const ContinuumProvider = ({ children, id }: ContinuumProviderProps) => (
  <BaseProvider
    extraComponents={EXTRA_COMPONENTS}
    id={id}
  >
    {children}
  </BaseProvider>
);

export const ContinuumTestingProvider =
  buildStyledContinuumTestingProvider(EXTRA_COMPONENTS);
